import { EChartsOption } from 'echarts';

const BasicSunburstChartTemplate: EChartsOption = {
  tooltip: {
    trigger: 'item',
    formatter: '{b}: {c}',
  },
  toolbox: {
    feature: {
      saveAsImage: { show: true },
    },
  },
  levels: [
    // level 0: root node, hide label
    {
      label: {
        show: false,
      },
    },
    {
      label: {
        rotate: 0,
      },
    },
    {
      label: {
        rotate: 0,
      },
    },
  ],
  series: {
    type: 'sunburst',
    emphasis: {
      focus: 'ancestor',
    },
    radius: [0, '80%'],
    label: {
      textBorderColor: '#fff',
      textBorderWidth: 2,
      color: '#000',
      fontWeight: 'bold',
      fontSize: 10,
    },
  },
};

export default BasicSunburstChartTemplate;
